export default "__VITE_ASSET__ByIMsrRY__"